export default __webpack_public_path__ + "static/hero.js-ed5f4bb64ae33dd9614006d81308cdd2.svg";